import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { getStatusColor } from '../../data/helpers';

const { FiShield } = FiIcons;

const ComplianceSection = ({ assignedCampaigns = [] }) => {
  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
      <h3 className="text-sm font-semibold text-slate-700 mb-4 flex items-center gap-2">
        <SafeIcon icon={FiShield} className="text-teal-500" /> Compliance Status
      </h3>
      {assignedCampaigns.length === 0 ? (
        <p className="text-sm text-slate-400">No compliance records found.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-xs uppercase tracking-wider text-slate-400 border-b border-slate-100">
                <th className="pb-2 text-left font-semibold">Training</th>
                <th className="pb-2 text-left font-semibold">Due Date</th>
                <th className="pb-2 text-left font-semibold">Completed</th>
                <th className="pb-2 text-left font-semibold">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {assignedCampaigns.map(r => (
                <tr key={r.id} className="text-sm">
                  <td className="py-2.5 pr-4 text-slate-700 font-medium">{r.campaignName}</td>
                  <td className="py-2.5 pr-4 text-slate-500">{r.endDate || 'N/A'}</td>
                  <td className="py-2.5 pr-4 text-slate-500">{r.status === 'Completed' ? (r.endDate || 'Completed') : '—'}</td>
                  <td className="py-2.5">
                    <span className={`px-2 py-0.5 rounded-full text-xs font-semibold border ${getStatusColor(r.status)}`}>
                      {r.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ComplianceSection;